<script setup>
  const authStore = useAuthStore()
  const { fetchPresidentEntities } = useIsPresident()

  watch(
    () => authStore.user,
    (user) => {
      if (user) fetchPresidentEntities()
    },
    { immediate: true }
  )
</script>

<template>
  <div>
    <Toast position="bottom-center" />
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ClientOnly>
      <PrivacyCookieBanner />
      <PrivacyCookiePreferences />
    </ClientOnly>
  </div>
</template>
